import { RefreshCw, AlertTriangle, Settings2, CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";

const ago = (iso) => {
  if (!iso) return "never";
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const h = Math.round(mins / 60);
  return h < 24 ? `${h}h ago` : new Date(iso).toLocaleString();
};

export const SyncBar = ({ sync, onRefresh, onSettings, refreshing }) => {
  const running = sync?.running;
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="sync-bar">
      <div className="text-xs text-slate-500 flex items-center gap-1.5" data-testid="last-synced">
        {running ? (
          <span className="text-[#425B76] font-medium" data-testid="sync-progress">
            Syncing · {sync.phase}{sync.progress_total ? ` (${sync.progress}/${sync.progress_total})` : ""}
          </span>
        ) : (
          <>
            {!sync?.last_error && sync?.last_success_at && <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />}
            Last synced {ago(sync?.last_success_at)}
          </>
        )}
      </div>
      <Button variant="outline" size="sm" className="gap-2 border-slate-200" onClick={onRefresh} disabled={running || refreshing} data-testid="sync-now-button">
        <RefreshCw className={`w-4 h-4 ${running || refreshing ? "animate-spin" : ""}`} />
        {running ? "Syncing…" : "Sync now"}
      </Button>
      <Button variant="outline" size="sm" className="gap-2 border-slate-200" onClick={onSettings} data-testid="open-metrics-settings">
        <Settings2 className="w-4 h-4" /> Settings
      </Button>
    </div>
  );
};

export const SyncErrorBanner = ({ error }) => (
  <div className="flex items-start gap-2 p-3 rounded-lg border border-rose-200 bg-rose-50 text-sm text-rose-700" data-testid="sync-error-banner">
    <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
    <div>
      <p className="font-medium">The last HubSpot sync failed — showing the most recent saved data.</p>
      <p className="text-xs mt-0.5 break-words">{error}</p>
    </div>
  </div>
);
